import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const FullPageSpinnerRingStyles: SystemStyleObject<Theme> = {
  height: '100vh',
  width: '100%',
};
